export default "__VITE_ASSET__DrBddKRT__"